import { patchRequest } from 'utils/api/apiRequest'

export type Data =
  | {
      email: string
    }
  | {
      personalId: string
    }

export const patchForgotPassword = (payload: Data) => patchRequest(`/users/password/reset`, payload)
